import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IUpdateBaasPoolServiceTokensParams {
    siteId: string;
    poolId: string;
}

export interface IUpdateBaasPoolServiceTokensResult extends IResult {
  success?: {
    poolId: string;
  };
  error?: BaasEdgePoolError;
}

export class UpdateBaasPoolServiceTokensRequest extends Request<IUpdateBaasPoolServiceTokensParams, IUpdateBaasPoolServiceTokensResult> {
  constructor(params: IUpdateBaasPoolServiceTokensParams) {
    super('updateBaasPoolServiceTokens', params);
  }
}
